<template>
  <vuex-table
    :fields="fields"
    :options="options"
    :state="state"
    table_store="autocaller_v2/stats/details/table"
    @check="check"
  >
    <template slot="state" slot-scope="{ item }">
      <state-badge :value="item.state" :amd_human="item.amd_human" />
    </template>
    <template slot="hangup_cause" slot-scope="{ item }">
      <tooltip
        placement="top"
        min-width="200"
        max-width="200"
        theme="light"
        :content="$t(`autocaller_v2.campaign.tooltips.hangup_cause_code.${item.hangup_cause}`)"
      >
        {{ item.hangup_cause }}
      </tooltip>
    </template>
    <template slot="amd_result" slot-scope="{ item }">
      <tooltip
        v-if="item.amd_class && item.amd_result !== null"
        placement="top"
        min-width="350"
        max-width="350"
        theme="light"
        :content="item.amd_class"
      >
        {{ item.amd_result }}%
      </tooltip>
    </template>

    <template slot="actions" slot-scope="{ item }">
      <tooltip
        v-if="item.recording"
        placement="top"
        min-width="350"
        max-width="350"
        theme="light"
        :content="$t('shared.component.button.download')"
      >
        <a :href="item.recording" target="_blank">
          <img src="/img/icons/btn-download.svg" alt="" width="20" />
        </a>
      </tooltip>
    </template>
  </vuex-table>
</template>

<script>
  import { seconds_to_time } from '@shared/helpers/time';
  import { toUserDateWithTime } from '@shared/helpers/date_format';
  import StateBadge from './stats-badge-state';
  export default {
    components: {
      StateBadge
    },
    props: {
      f: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        options: true,
        state: [
          'task_id',
          'call_date',
          'progress_date',
          'answer_date',
          'connection_date',
          'end_date',
          'state',
          'duration',
          'duration_billed',
          'pdd',
          'queue_time',
          'hangup_cause',
          'amd_result',
          'recording'
          // 'type',
          // 'disconnection',
          // 'probability'
        ]
      };
    },
    computed: {
      fields() {
        return [
          {
            key: 'campaign_name',
            label: this.$t('autocaller_v2.stats.table.field.campaign')
          },
          {
            key: 'task_id',
            label: this.$t('autocaller_v2.stats.table.field.task_id'),
            sortable: true,
            class: { 'd-none': !this.state.includes('task_id') },
            checkbox: true
          },
          {
            key: 'src',
            label: this.$t('autocaller_v2.stats.table.field.src'),
            sortable: true
          },
          {
            key: 'dst',
            label: this.$t('autocaller_v2.stats.table.field.dst'),
            sortable: true
          },
          {
            key: 'call_date',
            label: this.$t('autocaller_v2.stats.table.field.call_date'),
            formatter: (value) => (value ? toUserDateWithTime(value) : ''),
            class: { 'd-none': !this.state.includes('call_date') },
            checkbox: true,
            sortable: true
          },
          {
            key: 'progress_date',
            label: this.$t('autocaller_v2.stats.table.field.progress_date'),
            formatter: (value) => (value ? toUserDateWithTime(value) : ''),
            class: { 'd-none': !this.state.includes('progress_date') },
            checkbox: true,
            sortable: true
          },
          {
            key: 'answer_date',
            label: this.$t('autocaller_v2.stats.table.field.answer_date'),
            formatter: (value) => (value ? toUserDateWithTime(value) : ''),
            thStyle: { minWidth: '120px' },
            class: { 'd-none': !this.state.includes('answer_date') },
            checkbox: true,
            sortable: true
          },
          {
            key: 'connection_date',
            label: this.$t('autocaller_v2.stats.table.field.connection_date'),
            formatter: (value) => (value ? toUserDateWithTime(value) : ''),
            thStyle: { minWidth: '130px' },
            class: { 'd-none': !this.state.includes('connection_date') },
            checkbox: true
          },
          {
            key: 'end_date',
            label: this.$t('autocaller_v2.stats.table.field.end_date'),
            formatter: (value) => (value ? toUserDateWithTime(value) : ''),
            thStyle: { minWidth: '140px' },
            class: { 'd-none': !this.state.includes('end_date') },
            checkbox: true
          },
          {
            key: 'state',
            label: this.$t('autocaller_v2.stats.table.field.status'),
            sortable: true,
            class: { 'd-none': !this.state.includes('state') },
            checkbox: true
          },
          {
            key: 'duration',
            label: this.$t('autocaller_v2.stats.table.field.duration'),
            formatter: (value) => seconds_to_time(value),
            sortable: true,
            class: { 'd-none': !this.state.includes('duration') },
            checkbox: true
          },
          {
            key: 'duration_billed',
            label: this.$t('autocaller_v2.stats.table.field.duration_billed'),
            formatter: (value) => seconds_to_time(value),
            sortable: true,
            class: { 'd-none': !this.state.includes('duration_billed') },
            checkbox: true
          },
          {
            key: 'pdd',
            label: this.$t('autocaller_v2.stats.table.field.pdd'),
            formatter: (value) => seconds_to_time(value),
            thStyle: { minWidth: '210px', width: '210px' },
            class: { 'd-none': !this.state.includes('pdd') },
            checkbox: true
          },
          {
            key: 'queue_time',
            label: this.$t('autocaller_v2.stats.table.field.queue_time'),
            formatter: (value) => seconds_to_time(value),
            thStyle: { minWidth: '210px', width: '210px' },
            class: { 'd-none': !this.state.includes('queue_time') },
            checkbox: true
          },
          {
            key: 'hangup_cause',
            label: this.$t('autocaller_v2.stats.table.field.hangup_cause'),
            thStyle: { minWidth: '120px' },
            class: { 'd-none': !this.state.includes('hangup_cause') },
            checkbox: true
          },
          {
            key: 'amd_result',
            label: this.$t('autocaller_v2.stats.table.field.amd_result'),
            formatter: (val) => this.$numeral.percentage(val),
            percentage: true,
            class: { 'd-none': !this.state.includes('amd_result') },
            checkbox: true
          },
          {
            key: 'recording',
            label: this.$t('autocaller_v2.stats.table.field.recording'),
            thStyle: { width: '300px', display: 'block' },
            class: { 'd-none': !this.state.includes('recording') },
            checkbox: true
          },
          {
            key: 'actions',
            label: this.$t('shared.component.table.actions'),
            sortable: false,
            class: 'text-center'
          }
          // {
          //   key: 'type',
          //   label: this.$t('autocaller_v2.stats.table.field.type'),
          //   sortable: true,
          //   thStyle: { minWidth: '120px' },
          //   class: { 'd-none': !this.state.includes('type') },
          //   checkbox: true
          // },
          // {
          //   key: 'disconnection',
          //   label: this.$t('autocaller_v2.stats.table.field.disconnection'),
          //   sortable: true,
          //   thStyle: { minWidth: '120px' },
          //   class: { 'd-none': !this.state.includes('disconnection') },
          //   checkbox: true
          // },
          // {
          //   key: 'probability',
          //   label: this.$t('autocaller_v2.stats.table.field.probability'),
          // sortable: true,
          //   thStyle: { minWidth: '120px' },
          //   class: { 'd-none': !this.state.includes('probability') },
          //   checkbox: true
          // }
        ];
      }
    },
    methods: {
      check(state) {
        this.state = state;
      }
    }
  };
</script>
